import {useEffect} from 'react';


/**
 * @param querySelector {string} Query selector for intersection target
 * @param onScroll {function} Callback with argument
 */
const onScroll = function (querySelector, onScroll) {

    useEffect(() => {

        // older mobile safaris don't have InteractionObserver, showing all the time
        if (!window.IntersectionObserver) {

            return onScroll(true);
        }

        let options = {
            root: null,
            rootMargin: '80px 0px 0px 0px',
            threshold: 1
        };

        const onIntersect = entries => {

            onScroll(entries[0].isIntersecting);
        };

        const target = document.querySelector(querySelector);
        if (!target) {

            return;
        }

        let observer = new IntersectionObserver(onIntersect, options);
        observer.observe(target);

        return () => observer.unobserve(target);

    }, []);
};


export default onScroll;
